import React, { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { initGA } from '../utils/analytics';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { language } = useLanguage();

  const translations = {
    en: {
      message: "We use cookies to analyze site traffic and improve your experience. By clicking 'Accept', you consent to our use of cookies.",
      accept: "Accept",
      decline: "Decline",
      learnMore: "Learn more"
    },
    fr: {
      message: "Nous utilisons des cookies pour analyser le trafic du site et améliorer votre expérience. En cliquant sur 'Accepter', vous consentez à notre utilisation des cookies.",
      accept: "Accepter",
      decline: "Refuser",
      learnMore: "En savoir plus"
    }
  };

  const t = translations[language];

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookie-consent');
    
    if (consent === null) {
      // No choice made yet, show banner after 1 second
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    } else if (consent === 'accepted') {
      // User previously accepted, initialize GA
      initGA();
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
    initGA();
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-slide-up">
      <div className="max-w-6xl mx-auto bg-white rounded-xl shadow-2xl border-2 border-slate-200 p-6 md:flex items-center justify-between gap-6">
        <div className="flex items-start gap-4 mb-4 md:mb-0 flex-1">
          <Cookie className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" />
          <div>
            <p className="text-slate-700 text-sm md:text-base leading-relaxed">
              {t.message}
            </p>
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 md:flex-shrink-0">
          <button
            onClick={handleDecline}
            className="px-6 py-2.5 text-slate-600 hover:text-slate-800 font-medium transition-colors border-2 border-slate-200 rounded-lg hover:border-slate-300"
          >
            {t.decline}
          </button>
          <button
            onClick={handleAccept}
            className="px-6 py-2.5 bg-teal-600 text-white font-medium rounded-lg hover:bg-teal-700 transition-colors"
          >
            {t.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
